var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M922.427 43.714h-762.586c-52.427 0-94.846 42.896-94.846 95.323l-0.477 857.907 190.646-190.647h667.263c52.429 0 95.32-42.898 95.32-95.323v-571.938c0-52.427-42.891-95.323-95.32-95.323zM922.427 710.975h-706.822l-55.764 55.767v-627.705h762.586v571.938zM469.641 615.652h357.459v-95.323h-262.136l-95.323 95.323zM653.614 335.879c9.532-9.533 9.532-24.308 0-33.84l-84.361-84.361c-9.533-9.533-24.308-9.533-33.84 0l-280.25 280.249v117.724h117.723l280.727-279.773z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReview);
export default __webpack_public_path__ + "static/media/icon-review.3e4431ab6ef642c286c84e50cd4c18e0.svg";
export { ForwardRef as ReactComponent };